import ErrorBoundary from './ErrorBoundary'

import './locales'

export default ErrorBoundary
